import React, { useEffect, useRef } from 'react';
import translationInstance from '../../utils/translations';
import { useConfigurator } from '../../context/ConfiguratorContext';
import './ConfiguratorViewer.scss';
import OptionsPanel from '../OptionsPanel/OptionsPanel';
import logo from '../../assets/images/Logo.png';

const ConfiguratorViewer: React.FC = () => {
    const {
        currentConfig,
        isLoading,
        setIsLoading,
        setSketchfabApi,
        selectedLanguage
    } = useConfigurator();
    
    // Get translation function
    const t = translationInstance.t.bind(translationInstance);
    
    // Make sure we're using the current language
    translationInstance.setLanguage(selectedLanguage);
    const containerRef = useRef<HTMLDivElement>(null);
    const frameRef = useRef<HTMLIFrameElement>(null);

    // Effect to initialize the configurator with the legacy-style implementation
    useEffect(() => {
        if (!currentConfig) {
            return;
        }

        setIsLoading(true);

        const initViewer = async () => {

            if (!frameRef.current) {
                console.error('Frame element not found');
                return;
            }

            const client = new window.Sketchfab(frameRef.current);
            console.log(currentConfig.viewer.modelId);

            client.init(currentConfig.viewer.modelId, {
                success: async (api: any) => {
                    window.virtenzoInstance = await window.virtenzo(client, api, currentConfig);
                    
                    api.addEventListener('textureLoadProgress', (factor: any) => {
                        if (factor.progress === 1) setIsLoading(false);
                    });
                },
                error: (error: any) => {
                    console.warn('Sketchfab initialization failed:', error);
                },
                camera: 0,
                ui_ar: false,
                ui_help: false,
                ui_settings: false,
                ui_vr: false,
                ui_watermark: false,
                ui_stop: false,
                ui_loading: false,
                ui_infos: false,
                ui_general_controls: true,
                ui_inspector: false
            });

        }
        initViewer();
    }, [currentConfig, setIsLoading, setSketchfabApi]);

    return (
        <div className="configurator-viewer-container">
            <div ref={containerRef} className="virtenzo-viewer" id="virtenzo-frame">
                {process.env.REACT_APP_SHOW_LOGO === '1' && (
                  <div className='brand-logo'>
                    <img src={logo} alt="Brand logo" />
                  </div>
                )}
                <iframe ref={frameRef} src="null" id="virtenzo-frame" className="virtenzo-frame" width="100%" height="100%" frameBorder="0"
                    allow=""></iframe>
                <div className={`loading-overlay ${!isLoading ? 'hidden' : ''}`}>
                    <div className="spinner"></div>
                    <p>{t('virtenzo.configurator.loading')}</p>
                </div>
            </div>
            <OptionsPanel />
        </div>
    );
};

export default ConfiguratorViewer;
